import { render, staticRenderFns } from "./DateTime.vue?vue&type=template&id=40f98f4d&scoped=true&"
import script from "./DateTime.vue?vue&type=script&lang=ts&"
export * from "./DateTime.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f98f4d",
  null
  
)

export default component.exports